export default "__VITE_ASSET__db226a29__"